import $ from '../lib/jquery';

export class Component {
    $elements = [];

    /**
     * Selector to look for on the page.
     * Intended to be overwritten by child class.
     * @type {string}
     */
    selector = '';

    /**
     * Set to true in subclass to disable selecting elements.
     * Init will be called as soon as the Component is instantiated
     * @type {boolean}
     */
    skipSetup = false;

    /**
     *  Lifecycle method that runs if any elements are found.
     *  Intended to be overwritten by child class.
     */
    init() {}

    static create() {
        const instance = new this();
        // eslint-disable-next-line no-underscore-dangle
        instance._start();
        return instance;
    }

    /**
     * @private
     */
    _start() {
        if (this.skipSetup) {
            this.init();
            return;
        }

        if (this.selector === '') {
            throw new Error('No selector provided');
        }

        this.$elements = $(this.selector);

        if (!this.$elements.length) return;

        this.init();
    }
}



// WEBPACK FOOTER //
// ./assets/js/core/component.js